// src/components/aiTalentDrive/DriveCompanyLogos.tsx
// Logo wall of companies hiring through the AI Talent Drive. Hardcoded for
// now (not Sanity-driven) — update COMPANIES below to add/remove a company,
// with its logo placed in public/images/ai-talent-drive/companies/.
import type { ReactNode } from "react";

type DriveCompany = {
  name: string;
  file: string;
  note?: string;
  website?: string;
};

const COMPANIES: DriveCompany[] = [
  { name: "FlexiLoans", file: "flexiloans" },
  { name: "Infimatrix", file: "infimatrix" },
  { name: "Trovex.ai", file: "trovex" },
  { name: "Neowise", file: "neowise" },
  { name: "Ketto", file: "ketto" },
  { name: "IDeaS", file: "ideas" },
  { name: "Alchemyst AI", file: "alchemyst-ai" },
  { name: "CraftersWealth", file: "crafterswealth" },
  { name: "Riko AI", file: "riko-ai" },
];

const PARTNERS: DriveCompany[] = [
  { name: "SINE, IIT Bombay", file: "sine" },
  { name: "BonBillo", file: "bonbillo" },
];

const logoSrc = (c: DriveCompany, kind: "companies" | "partners") =>
  `/images/ai-talent-drive/${kind}/${c.file}.png`;

function LogoTile({ c, kind }: { c: DriveCompany; kind: "companies" | "partners" }) {
  const img: ReactNode = (
    <img src={logoSrc(c, kind)} alt={c.name} loading="lazy" />
  );
  return (
    <li className="dl-item" key={c.file}>
      <div className="dl-tile" title={c.name}>
        {c.website ? (
          <a href={c.website} target="_blank" rel="noopener noreferrer">
            {img}
          </a>
        ) : (
          img
        )}
      </div>
      {c.note && <span className="dl-note">{c.note}</span>}
    </li>
  );
}

export default function DriveCompanyLogos() {
  if (COMPANIES.length === 0) return null;

  return (
    <section className="dl">
      <div className="section-head section-head--center">
        <h2>
          Companies <span className="grad-text">hiring</span> in this drive
        </h2>
      </div>

      <div className="dl-card">
        <div className="dl-partners-label dl-partners-label--first">
          Latest onboarded hiring companies
        </div>
        <ul className="dl-grid dl-grid--companies">
          {COMPANIES.map((c) => (
            <LogoTile c={c} kind="companies" key={c.file} />
          ))}
          <li className="dl-more-row">
            <div className="dl-more">
              <span className="dl-more-dot" aria-hidden="true" />
              <span className="dl-more-text">
                <strong>More companies</strong> onboarding every day
              </span>
            </div>
          </li>
        </ul>

        {PARTNERS.length > 0 && (
          <>
            <div className="dl-partners-label">In partnership with</div>
            <ul className="dl-grid dl-grid--partners">
              {PARTNERS.map((p) => (
                <LogoTile c={p} kind="partners" key={p.file} />
              ))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
}
